<template>
  <div>
    <el-form :inline="true">
      <el-form-item>
        <el-button type="primary" @click="dialogVisible = true">新增</el-button>
      </el-form-item>
    </el-form>

    <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            border
            stripe>
      <el-table-column
              prop="name"
              label="类型名称"
              width="160">
      </el-table-column>
      <el-table-column
              prop="code"
              label="类型编码"
              width="120">
      </el-table-column>
      <el-table-column
              prop="numRange"
              label="评分范围"
              width="120">
      </el-table-column>
      <el-table-column
              prop="describes"
              label="描述">
      </el-table-column>
      <el-table-column
              prop="sort"
              label="排序"
              width="80">
      </el-table-column>
      <el-table-column
              prop="delFlag"
              label="状态"
              width="100">
        <template slot-scope="scope">
          <el-tag size="small" v-if="scope.row.delFlag == 0" type="success">启用</el-tag>
          <el-tag size="small" v-else-if="scope.row.delFlag == 1" type="info">停用</el-tag>
        </template>
      </el-table-column>
      <el-table-column
              prop="icon"
              label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="editHandle(scope.row.id)">编辑</el-button>
          <el-divider direction="vertical"></el-divider>

          <template>
            <el-popconfirm title="这是一段内容确定删除吗？" @confirm="delHandle(scope.row.id, scope.row.delFlag)">
              <el-button type="text" slot="reference">删除</el-button>
            </el-popconfirm>
          </template>
          <el-divider direction="vertical"></el-divider>

          <el-button v-if="scope.row.delFlag == 1" type="text" @click="handleFlag(scope.row.id, 0)">启用</el-button>
          <el-button v-else type="text" @click="handleFlag(scope.row.id, 1)">停用</el-button>
        </template>
      </el-table-column>

    </el-table>

    <!--新增对话框-->
    <el-dialog
            :title="editForm.id == null ? '新增': '编辑'"
            :visible.sync="dialogVisible"
            width="500px"
            :before-close="handleClose">

      <el-form :model="editForm" :rules="editFormRules" ref="editForm" :label-width="'110px'">
        <el-form-item label="类型名称" prop="name">
          <el-input :disabled="editForm.id !== null && editForm.id !== '' ? true : false" v-model="editForm.name" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="类型编码" prop="code">
          <el-input :disabled="editForm.id !== null && editForm.id !== '' ? true : false" v-model="editForm.code" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="评分范围" prop="numRange">
          <el-input v-model="editForm.numRange" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="describes">
          <el-input type="textarea" :rows="3" v-model="editForm.describes" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input v-model="editForm.sort" style="width: 300px"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm('editForm')">取 消</el-button>
        <el-button type="primary" @click="submitForm('editForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "platformType",
    data() {
      return {
        dialogVisible: false,
        tableData: [],
        editForm: {
          id: '',
          name: '',
          code: '',
          numRange: '',
          describes: '',
          sort: ''
        },
        editFormRules: {
          name: [
            {required: true, message: '请输入类型名称', trigger: 'blur'}
          ],
          code: [
            {required: true, message: '请输入类型编码', trigger: 'blur'}
          ],
          /*numRange: [
            {required: true, message: '请输入数值范围', trigger: 'blur'}
          ],*/
          describes: [
            {required: true, message: '请输入类型描述', trigger: 'blur'}
          ],
          sort: [
            {required: true, message: '请输入类型序号', trigger: 'blur'}
          ]
        }
      }
    },
    created() {
      this.getQuestesTypeList()
    },
    methods: {
      editHandle(id) {
        this.$axios.get('/uxm/questes-type/info/' + id).then(res => {
          this.editForm = res.data.data
          this.dialogVisible = true
        })
      },
      delHandle(id, flag) {
        if (flag === 0) {
          return this.$message.warning("正在启用的情况下不能删除，请停用再删除！");
        }
        this.$axios.post('/uxm/questes-type/remove/'+ id).then(res => {
          this.$message({
            showClose: true,
            message: '删除成功',
            type: 'success'
          });
          this.getQuestesTypeList()
        })
      },
      getQuestesTypeList() {
        this.$axios.get("/uxm/questes-type/list", {}).then(res => {
          this.tableData = res.data.data
        })
      },
      handleClose() {
        this.resetForm('editForm')
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
        this.dialogVisible = false
        this.editForm = { id: '' }
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$axios.post('/uxm/questes-type/' + (this.editForm.id ? 'edit' : 'add'), this.editForm)
              .then(res => {
                this.$message({
                  showClose: true,
                  message: '恭喜你，操作成功',
                  type: 'success'
                });
                this.dialogVisible = false
                this.resetForm(formName)
                this.getQuestesTypeList()
              })
          } else {
            return false;
          }
        });
      },
      handleFlag(id, state) {
        this.$confirm('是否确认进行此操作?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios.post('/uxm/questes-type/enableAndDisable/' + id +'/'+ state).then(res => {
            console.log('res',res)
            if (res.data.code == 200) {
              this.$message({
                showClose: true,
                message: '操作成功',
                type: 'success'
              });
              this.getQuestesTypeList()
            } else {
              this.$message.error('操作失败');
            }
          })
        }).catch(() => {
        });
      }
    }
  }
</script>

<style scoped>

</style>
